import { cn } from "@/lib/utils"
import logoDark from '@/assets/images/logo_no_bg.png'

interface LoadingProps {
  className?: string
  size?: "sm" | "md" | "lg"
}

export function Loading({ className, size = "md" }: LoadingProps) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12", 
    lg: "w-16 h-16"
  }

  return (
    <div className={cn("flex items-center justify-center min-h-[200px]", className)}>
      <div className="relative">
        <img
          src={logoDark}
          alt="Loading..."
          className={cn(
            "animate-zoom-in-out",
            sizeClasses[size]
          )}
        />
      </div>
    </div>
  )
} 